import React, { useCallback, useContext } from 'react'

import {
  useFormDataV2,
  useFormValidation,
  validateIsNotBlankWithLocale,
  validatePhoneWithLocale,
} from '@monorepo/utils'
import PhoneInput from './PhoneInput'
import { RegField } from './types'
import { ApiCore, Locale, useRegister } from '@monorepo/api'
import { ContextApp } from '@monorepo/service'
import { parsePhoneNumber } from 'libphonenumber-js'
import { bonus } from '../../constants'

const VALIDATORS = {
  rules: {
    clean_phone: [validateIsNotBlankWithLocale, validatePhoneWithLocale],
  },
  defaultData: {
    clean_phone: '+7',
  },
}

const FormRegister: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { sid, setDataRegister } = useContext(ContextApp)

  const { handleRequest, commonErrorMsg, fieldErrorMsg, isLoading } = useRegister({
    sid,
    bonusId: bonus?.bonusId,
    setDataRegister,
  })

  const phoneErrorMessage = fieldErrorMsg ? fieldErrorMsg['clean_phone'] : null

  const { validateForm } = useFormValidation(VALIDATORS.rules)
  const { form, onValidate, setForm } = useFormDataV2({
    validateForm,
    defaultData: VALIDATORS.defaultData,
  })

  const handlePhoneChange = useCallback(
    (key: keyof RegField, value: RegField[typeof key]) => {
      setForm((form) => ({
        ...form,
        data: {
          ...form.data,
          [key]: value,
        },
      }))
    },
    [setForm],
  )

  const handleSubmit = useCallback(() => {
    onValidate('clean_phone')((data) => {
      const { nationalNumber, countryCallingCode } = parsePhoneNumber(data.clean_phone)

      handleRequest({
        account_registered_by: ApiCore.PublicAccountRegistrationTypeEnum.PhoneNumber,
        language: Locale.get(),
        country_of_residence: 'KAZ',
        currency: 'KZT',
        privacy_policy: true,
        terms_and_conditions: true,
        receive_promos_enabled: true,
        clean_phone: Number(nationalNumber),
        phone_country_code: `+${countryCallingCode}`,
      })
    })
  }, [handleRequest, onValidate])

  return (
    <>
      <PhoneInput
        phoneNumber={form.data.clean_phone}
        onChange={handlePhoneChange}
        onValidate={onValidate}
        error={commonErrorMsg ?? phoneErrorMessage ?? form.errors.clean_phone}
      />
      {React.isValidElement(children)
        ? React.cloneElement(children as React.ReactElement, {
            onClick: handleSubmit,
            isloading: isLoading ? 'loading' : '',
            disabled: form.data.clean_phone.length !== 12,
          })
        : null}
    </>
  )
}

export default FormRegister
